// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DocumentShow_wrapper__28T9k","container":"DocumentShow_container__1a7cD","card":"DocumentShow_card__lE3xR","actions":"DocumentShow_actions__2gTl5"};